import { render, staticRenderFns } from "./Nachricht.vue?vue&type=template&id=542ab7f6&scoped=true"
import script from "./Nachricht.vue?vue&type=script&lang=js"
export * from "./Nachricht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ab7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542ab7f6')) {
      api.createRecord('542ab7f6', component.options)
    } else {
      api.reload('542ab7f6', component.options)
    }
    module.hot.accept("./Nachricht.vue?vue&type=template&id=542ab7f6&scoped=true", function () {
      api.rerender('542ab7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Nachricht.vue"
export default component.exports